import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "assets/css/App.css";

import {
  HashRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";

import AuthLayout from "layouts/auth";
import AdminLayout from "layouts/admin";

import { ChakraProvider } from "@chakra-ui/react";
import theme from "theme/theme";
import { ThemeEditorProvider } from "@hypertheme-editor/chakra-ui";
import UnauthorizedPage from "./Unauthorized";
import "./i18n"; // i18n config

// SOCKET PROVIDERS
import { OrdersProvider } from "contexts/OrdersContext";
import { UnseenOrdersProvider } from "contexts/UnseenOrdersContext";

const hasPermission = (pathname) => {
  const role_id = sessionStorage.getItem("role_id");

  // Super admin full access
  if (role_id === "1") return true;

  const role = JSON.parse(sessionStorage.getItem("permissions") || "{}");
  if (!role.permissions) return false;

  const parts = pathname.split("/").filter(Boolean);
  const lastParam = parts[parts.length - 1];

  return role.permissions.some(
    (permission) =>
      permission.page_access &&
      permission.page_category === "uclean_admin" &&
      permission.page_name.toLowerCase() === lastParam.toLowerCase()
  );
};

const RootRedirect = () => {
  const history = useHistory();

  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const role_id = sessionStorage.getItem("role_id");

    if (accessToken) {
      if (role_id === "1") {
        history.replace("/admin/Ai Dashboard");
      } else {
        history.replace("/admin/Main Dashboard");
      }
    } else {
      history.replace("/auth");
    }
  }, [history]);

  return null;
};

// -----------------------------
// MAIN RENDER
// -----------------------------
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ChakraProvider theme={theme}>
    <ThemeEditorProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <HashRouter>
          <Switch>
            {/* Auth Routes */}
            <Route path="/auth" component={AuthLayout} />

            {/* ADMIN ROUTES WRAPPED WITH PROVIDERS */}
            <Route
              path="/admin"
              render={(props) =>
                hasPermission(props.location.pathname) ? (
                  <OrdersProvider>
                    <UnseenOrdersProvider>
                      <AdminLayout {...props} />
                    </UnseenOrdersProvider>
                  </OrdersProvider>
                ) : (
                  <UnauthorizedPage />
                )
              }
            />

            <Route path="/auth/unauthorized" component={UnauthorizedPage} />

            <Route exact path="/" component={RootRedirect} />

            <Redirect to="/auth" />
          </Switch>
        </HashRouter>
      </Suspense>
    </ThemeEditorProvider>
  </ChakraProvider>
);
